export class FileCannotReadbleError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export class NoFileSelectedError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export class MissingRequiredCsvColumnsError extends Error {
  columns: string[];

  constructor(message: string, columns: string[] = []) {
    super(message);
    this.columns = columns;
  }
}

export class InvalidFileTypeError extends Error {
  constructor(message: string) {
    super(message);
  }
}
